import { Operators, OperatorsDef, } from "@/components/fields/base/BaseSearchField";
/** Opérateur de recherche pour le champ de type id*/
export var operators = [
    OperatorsDef[Operators.OPERATOR_EQUAL],
    OperatorsDef[Operators.OPERATOR_STARTS_WITH],
    OperatorsDef[Operators.OPERATOR_CONTAINS],
    OperatorsDef[Operators.OPERATOR_ENDS_WITH],
];
